import { render } from "./AchievementHolderMobile.vue?vue&type=template&id=5917a9f4"
import script from "./AchievementHolderMobile.vue?vue&type=script&lang=js"
export * from "./AchievementHolderMobile.vue?vue&type=script&lang=js"

import exportComponent from "/Users/connorklaassen/Documents/Programming/cklaassen.github.io/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__